const aribVttStyles = {
  "ssz" : "::cue(.ssz) {\n  font-size: 0.5em !important;\n  'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', 'Meiryo', sans-serif, 'wlcmaru2004aribu';\nvertical-align:bottom;\n}",
  "msz" : "::cue(.msz) {\n  transform: scale(0.5,1);\n  transform-origin: left top;\n  font-family: 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', 'Meiryo', sans-serif, 'wlcmaru2004aribu';\n}",
  "nsz" : "::cue(.nsz) {\n  font-family: 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', 'メイリオ', 'Meiryo', sans-serif, 'wlcmaru2004aribu';\n}",
  "stl" : "::cue(.stl) {\n  text-decoration: underline;\n}",
  "orn-stroke" : "::cue(.orn-stroke) {\n  text-shadow: 0.5px 0.5px 0 black,\n  -0.5px 0.5px 0 black,\n  0.5px -0.5px 0 black,\n  -0.5px -0.5px 0 black;\n  text-shadow: 0.5px 0.5px 0.5px black,\n  -0.5px 0.5px 0.5px black,\n  0.5px -0.5px 0.5px black,\n  -0.5px -0.5px 0.5px black;\n}",
  // palette
  "colors": {
    "bkf-p0" : "rgba(0, 0, 0, 1)",
    "p0-0" : "rgba(0, 0, 0, 1)",
    "rdf-p0" : "rgba(255, 0, 0, 1)",
    "p0-1" : "rgba(255, 0, 0, 1)",
    "grf-p0" : "rgba(0, 255, 0, 1)",
    "p0-2" : "rgba(0, 255, 0, 1)",
    "ylf-p0" : "rgba(255, 255, 0, 1)",
    "p0-3" : "rgba(255, 255, 0, 1)",
    "blf-p0" : "rgba(0, 0, 255, 1)",
    "p0-4" : "rgba(0, 0, 255, 1)",
    "mgf-p0" : "rgba(255,0,255, 1)",
    "p0-5" : "rgba(255,0, 255, 1)",
    "cnf-p0" : "rgba(0, 255,255,1)",
    "p0-6" : "rgba(0, 255, 255, 1)",
    "whf-p0" : "rgba(255, 255, 255, 1)",
    "p0-7" : "rgba(255, 255, 255, 1)",
    "p0-8" : "rgba(0, 0, 0, 0)",
    "p0-9" : "rgba(255, 0, 0, 1)",
    "p0-10" : "rgba(0, 170, 0, 1)",
    "p0-11" : "rgba(170, 170, 0, 1)",
    "p0-12" : "rgba(0, 0, 170, 1)",
    "p0-13" : "rgba(170, 0, 170, 1)",
    "p0-14" : "rgba(0, 170, 170, 1)",
    "p0-15" : "rgba(170, 170, 170, 1)",
    "bkf-p1" : "rgba(0, 0, 85, 1)",
    "p1-0" : "rgba(0, 0, 85, 1)",
    "rdf-p1" : "rgba(0, 85, 0, 1)",
    "p1-1" : "rgba(0, 85, 0, 1)",
    "grf-p1" : "rgba(0, 85, 85, 1)",
    "p1-2" : "rgba(0, 85, 85, 1)",
    "ylf-p1" : "rgba(0, 85, 170, 1)",
    "p1-3" : "rgba(0, 85, 170, 1)",
    "blf-p1" : "rgba(0, 85, 255, 1)",
    "p1-4" : "rgba(0, 85, 255, 1)",
    "mgf-p1" : "rgba(0, 170, 85, 1)",
    "p1-5" : "rgba(0, 170, 85, 1)",
    "cnf-p1" : "rgba(0, 170, 255, 1)",
    "p1-6" : "rgba(0, 170, 255, 1)",
    "whf-p1" : "rgba(0, 255, 85, 1)",
    "p1-7" : "rgba(0, 255, 85, 1)",
    /*palette 1 */
    "p1-8" : "rgba(0, 255, 170, 1)",
    "p1-9" : "rgba(85, 0, 0, 1)",
    "p1-10" : "rgba(85, 0, 85, 1)",
    "p1-11" : "rgba(85, 0, 170, 1)",
    "p1-12" : "rgba(85, 0, 255, 1)",
    "p1-13" : "rgba(85, 85, 0, 1)",
    "p1-14" : "rgba(85, 85, 85, 1)",
    "p1-15" : "rgba(85, 85, 170, 1)",
    /*palette 2 */
    "bkf-p2" : "rgba(85,  85, 255, 1)",
    "p2-0" : "rgba(85,  85, 255, 1)",
    "rdf-p2" : "rgba(85, 170,   0, 1)",
    "p2-1" : "rgba(85, 170,   0, 1)",
    "grf-p2" : "rgba(85, 170,  85, 1)",
    "p2-2" : "rgba(85, 170,  85, 1)",
    "ylf-p2" : "rgba(85, 170, 170, 1)",
    "p2-3" : "rgba(85, 170, 170, 1)",
    "blf-p2" : "rgba(85, 170, 255, 1)",
    "p2-4" : "rgba(85, 170, 255, 1)",
    "mgf-p2" : "rgba(85, 255,   0, 1)",
    "p2-5" : "rgba(85, 255,   0, 1)",
    "cnf-p2" : "rgba(85, 255,  85, 1)",
    "p2-6" : "rgba(85, 255,  85, 1)",
    "whf-p2" : "rgba(85, 255, 170, 1)",
    "p2-7" : "rgba(85, 255, 170, 1)",
    "p2-8" : "rgba(85, 255, 255, 1)",
    "p2-9" : "rgba(170,   0,  85, 1)",
    "p2-10" : "rgba(170,   0, 255, 1)",
    "p2-11" : "rgba(170,  85,   0, 1)",
    "p2-12" : "rgba(170,  85,  85, 1)",
    "p2-13" : "rgba(170,  85, 170, 1)",
    "p2-14" : "rgba(170, 85, 255, 1)",
    "p2-15" : "rgba(170, 170, 85, 1)",
    /*palette 3 */
    "bkf-p3" : "rgba(170, 170, 255, 1)",
    "p3-0" : "rgba(170, 170, 255, 1)",
    "rdf-p3" : "rgba(170, 255,   0, 1)",
    "p3-1" : "rgba(170, 255,   0, 1)",
    "grf-p3" : "rgba(170, 255,  85, 1)",
    "p3-2" : "rgba(170, 255,  85, 1)",
    "ylf-p3" : "rgba(170, 255, 170, 1)",
    "p3-3" : "rgba(170, 255, 170, 1)",
    "blf-p3" : "rgba(170, 255, 255, 1)",
    "p3-4" : "rgba(170, 255, 255, 1)",
    "mgf-p3" : "rgba(255,   0,  85, 1)",
    "p3-5" : "rgba(255,   0,  85, 1)",
    "cnf-p3" : "rgba(255,   0, 170, 1)",
    "p3-6" : "rgba(255,   0, 170, 1)",
    "whf-p3" : "rgba(255,  85,   0, 1)",
    "p3-7" : "rgba(255,  85,   0, 1)",
    "p3-8" : "rgba(255,  85,  85, 1)",
    "p3-9" : "rgba(255,  85, 170, 1)",
    "p3-10" : "rgba(255,  85, 255, 1)",
    "p3-11" : "rgba(255, 170,   0, 1)",
    "p3-12" : "rgba(255, 170,  85, 1)",
    "p3-13" : "rgba(255, 170, 170, 1)",
    "p3-14" : "rgba(255, 170, 255, 1)",
    "p3-15" : "rgba(255, 255,  85, 1)",
    /*palette 4 */
    "bkf-p4" : "rgba(255, 255, 170, 1)",
    "p4-0" : "rgba(255, 255, 170, 1)",
    "rdf-p4" : "rgba(0,   0,   0, .5)",
    "p4-1" : "rgba(0,   0,   0, .5)",
    "grf-p4" : "rgba(255,   0,   0, .5)",
    "p4-2" : "rgba(255,   0,   0, .5)",
    "ylf-p4" : "rgba(  0, 255,   0, .5)",
    "p4-3" : "rgba(  0, 255,   0, .5)",
    "blf-p4" : "rgba(255, 255,   0, .5)",
    "p4-4" : "rgba(255, 255,   0, .5)",
    "mgf-p4" : "rgba(  0,   0, 255, .5)",
    "p4-5" : "rgba(  0,   0, 255, .5)",
    "cnf-p4" : "rgba(255,   0, 255, .5)",
    "p4-6" : "rgba(255,   0, 255, .5)",
    "whf-p4" : "rgba(  0, 255, 255, .5)",
    "p4-7" : "rgba(  0, 255, 255, .5)",
    "p4-8" : "rgba(255, 255, 255, .5)",
    "p4-9" : "rgba(170,   0,   0, .5)",
    "p4-10" : "rgba(  0, 170,   0, .5)",
    "p4-11" : "rgba(170, 170,   0, .5)",
    "p4-12" : "rgba(  0,   0, 170, .5)",
    "p4-13" : "rgba(170, 0, 170, .5)",
    "p4-14" : "rgba(0, 170, 170, .5)",
    "p4-15" : "rgba(170, 170, 170, .5)",
    /*palette 5 */
    "bkf-p5" : "rgba(0,   0,  85, .5)",
    "p5-0" : "rgba(0,   0,  85, .5)",
    "rdf-p5" : "rgba(0,  85,   0, .5)",
    "p5-1" : "rgba(0,  85,   0, .5)",
    "grf-p5" : "rgba(0,  85,  85, .5)",
    "p5-2" : "rgba(0,  85,  85, .5)",
    "ylf-p5" : "rgba(0,  85, 170, .5)",
    "p5-3" : "rgba(0,  85, 170, .5)",
    "blf-p5" : "rgba(0,  85, 255, .5)",
    "p5-4" : "rgba(0,  85, 255, .5)",
    "mgf-p5" : "rgba(0, 170,  85, .5)",
    "p5-5" : "rgba(0, 170,  85, .5)",
    "cnf-p5" : "rgba(0, 170, 255, .5)",
    "p5-6" : "rgba(0, 170, 255, .5)",
    "whf-p5" : "rgba(0, 255,  85, .5)",
    "p5-7" : "rgba(0, 255,  85, .5)",
    "p5-8" : "rgba(0, 255, 170, .5)",
    "p5-9" : "rgba(85,   0,   0, .5)",
    "p5-10" : "rgba(85,   0,  85, .5)",
    "p5-11" : "rgba(85,   0, 170, .5)",
    "p5-12" : "rgba(85,   0, 255, .5)",
    "p5-13" : "rgba(85,  85,   0, .5)",
    "p5-14" : "rgba(85,  85,  85, .5)",
    "p5-15" : "rgba(85,  85, 170, .5)",
    /*palette 6 */
    "bkf-p6" : "rgba(85,  85, 255, .5)",
    "p6-0" : "rgba(85,  85, 255, .5)",
    "rdf-p6" : "rgba(85, 170,   0, .5)",
    "p6-1" : "rgba(85, 170,   0, .5)",
    "grf-p6" : "rgba(85, 170,  85, .5)",
    "p6-2" : "rgba(85, 170,  85, .5)",
    "ylf-p6" : "rgba(85, 170, 170, .5)",
    "p6-3" : "rgba(85, 170, 170, .5)",
    "blf-p6" : "rgba(85, 170, 255, .5)",
    "p6-4" : "rgba(85, 170, 255, .5)",
    "mgf-p6" : "rgba(85, 255,   0, .5)",
    "p6-5" : "rgba(85, 255,   0, .5)",
    "cnf-p6" : "rgba(85, 255,  85, .5)",
    "p6-6" : "rgba(85, 255,  85, .5)",
    "whf-p6" : "rgba(85, 255, 170, .5)",
    "p6-7" : "rgba(85, 255, 170, .5)",
    "p6-8" : "rgba(85, 255, 255, .5)",
    "p6-9" : "rgba(170,   0,  85, .5)",
    "p6-10" : "rgba(170,   0, 255, .5)",
    "p6-11" : "rgba(170,  85,   0, .5)",
    "p6-12" : "rgba(170,  85,  85, .5)",
    "p6-13" : "rgba(170,  85, 170, .5)",
    "p6-14" : "rgba(170,  85, 255, .5)",
    "p6-15" : "rgba(170, 170,  85, .5)",
    /*palette 7 */
    "bkf-p7" : "rgba(170, 170, 255, .5)",
    "p7-0" : "rgba(170, 170, 255, .5)",
    "rdf-p7" : "rgba(170, 255,   0, .5)",
    "p7-1" : "rgba(170, 255,   0, .5)",
    "grf-p7" : "rgba(170, 255,  85, .5)",
    "p7-2" : "rgba(170, 255,  85, .5)",
    "ylf-p7" : "rgba(170, 255, 170, .5)",
    "p7-3" : "rgba(170, 255, 170, .5)",
    "blf-p7" : "rgba(170, 255, 255, .5)",
    "p7-4" : "rgba(170, 255, 255, .5)",
    "mgf-p7" : "rgba(255,   0,  85, .5)",
    "p7-5" : "rgba(255,   0,  85, .5)",
    "cnf-p7" : "rgba(255,   0, 170, .5)",
    "p7-6" : "rgba(255,   0, 170, .5)",
    "whf-p7" : "rgba(255,  85,   0, .5)",
    "p7-7" : "rgba(255,  85,   0, .5)",
    "p7-8" : "rgba(255,  85,  85, .5)",
    "p7-9" : "rgba(255,  85, 170, .5)",
    "p7-10" : "rgba(255,  85, 255, .5)",
    "p7-11" : "rgba(255, 170,   0, .5)",
    "p7-12" : "rgba(255, 170,  85, .5)",
    "p7-13" : "rgba(255, 170, 170, .5)",
    "p7-14" : "rgba(255, 170, 255, .5)",
    "p7-15" : "rgba(255, 255,  85, .5)"
  }
}

module.exports = aribVttStyles;



// WEBPACK FOOTER //
// ./src/hlsjs/arib-vtt-styles.js